import React, {useCallback, useEffect, useRef, useState} from 'react';
import useWindowDimensions from "../Wedgits/useWindowDimensions";
import axios from "axios";
import toast from "react-hot-toast";
import "../Css/HomePage.scss";
import Scrollbars from "react-custom-scrollbars-2";
import logo from "../Css/Backgrounds/R-ABNOS.svg";
import Gallery from "../Wedgits/Gallery";
import {Link} from "react-router-dom";
import 'swiper/css';
import {Swiper, SwiperSlide} from "swiper/react";
import swipeAnimation from "../Wedgits/swipe.json";
import {useLottie} from "lottie-react";
import {Navigation} from 'swiper/modules';
import {CenterModal} from "react-spring-modal";
import {NumericFormat} from "react-number-format";

function HomePage(props) {

    const {height, width} = useWindowDimensions();

    const options = {
        animationData: swipeAnimation,
        loop: 2
    };

    const {View} = useLottie(options);

    const [isLoading, setIsloading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState("");
    const [menuList, setMenuList] = useState([]);
    const [branchData, setBranchData] = useState("");
    const branchDataRef = useRef();
    const [defaultImg, setDefaultImg] = useState(null);

    let newTime = new Date().getTime();

    const fetchBranches = useCallback(async () => {
        setIsloading(true);
        setError(null);

        try {
            const Response = await axios.get(`/v1/branches`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "branch-code": axios.defaults.url,
                },
            });
            if (Response.status == 200) {
                setBranchData(Response.data.data.d[0]);
                branchDataRef.current = Response.data.data.d[0];
                fetchTags(Response.data.data.d[0]);
                setDefaultImg(Response.data.data.d[0].logo);
            }
        } catch (error) {
            toast.error(error.response.data.errors[0].msg);
            if ((error?.response?.status ?? 0) === 401) {
                localStorage.removeItem("token");
                // //console.log(error);
                setTimeout(() => {
                    window.location = "/";
                }, 2000);
            }
        }

        setIsloading(false);
    }, []);

    const [tagList, setTagList] = useState([]);
    const fetchTags = useCallback(async (branchData) => {
        setIsloading(true);
        setError(null);

        const loadedData = [];

        try {
            const Response = await axios.get(`/v1/meals/tags`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "branch-code": axios.defaults.url,
                },
            });
            if (Response.status == 200) {
                setTagList(Response.data.data.d);
                fetchMeals(Response.data.data.d[0]?.code);
            }
        } catch (error) {
            toast.error(error.response.data.errors[0].msg);
            if ((error?.response?.status ?? 0) === 401) {
                localStorage.removeItem("token");
                // //console.log(error);
                setTimeout(() => {
                    window.location = "/";
                }, 2000);
            }
        }

        setIsloading(false);
    }, []);

    const [selectedTag, setSelectedTag] = useState("");

    const fetchMeals = useCallback(async (tagCode, e) => {
        setIsloading(true);
        setError(null);

        const loadedData = [];

        try {
            const Response = await axios.get(`/v1/meals?tag_code=${tagCode}`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "branch-code": axios.defaults.url,
                },
            });
            if (Response.status == 200) {
                setMenuList(Response.data.data.d);
                setSelectedTag(tagCode);
                props.onSetIsFetchOver(true);
            }
        } catch (error) {
            toast.error(error.response.data.errors[0].msg);
            if ((error?.response?.status ?? 0) === 401) {
                localStorage.removeItem("token");
                // //console.log(error);
                setTimeout(() => {
                    window.location = "/";
                }, 2000);
            }
        }

        setIsloading(false);
    }, []);

    const getStatistics = useCallback(async () => {
        setIsloading(true);
        setError(null);
        let date = new Date();
        try {
            const Response = await axios.patch(
                `/v1/branches/statistics/menu_clicks`,
                {},
                {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                        "branch-code": axios.defaults.url,
                    },
                }
            );
            if (Response.status == 200) {
                localStorage.setItem("statistics", date.getTime());
            }
        } catch (error) {
            toast.error(error.response.data.errors[0].msg);
            if ((error?.response?.status ?? 0) === 401) {
                localStorage.removeItem("token");
                // //console.log(error);
                setTimeout(() => {
                    window.location = "/";
                }, 2000);
            }
        }

        setIsloading(false);
    }, []);

    const [menuModalOpen, setMenuModalOpen] = useState(false);

    const [selectedMenu, setSelectedMenu] = useState("");

    useEffect(() => {
        fetchBranches();
        if (!localStorage.getItem("statistics")) {
            getStatistics();
        } else {
            if ((parseInt(newTime) - parseInt(localStorage.getItem("statistics"))) > 600000) {
                getStatistics();
            }
        }
    }, []);
    const [SWDisable, setSWDisable] = useState(true);

    const handleNextSlide = () => {
        if (props.swiperRef.current && props.swiperRef.current.swiper) {
            props.swiperRef.current.swiper.slideNext(); // Go to the next slide
        }
    };

    const handleGoToSlide = (index) => {
        if (props.swiperRef.current && props.swiperRef.current.swiper) {
            props.swiperRef.current.swiper.slideTo(index); // Go to a specific slide
        }
    };

    return (
        <div className="homePageContainer">

            <CenterModal
                isOpen={menuModalOpen}
                onDismiss={() => {
                    setMenuModalOpen(false);
                }}
                overlayProps={{style: {zIndex: 1040}}}
                contentProps={{
                    style: {
                        width: "90%",
                        outline: "none",
                        maxWidth: 500,
                        padding: 0,
                        backgroundColor: "transparent"
                    }
                }}>
                <div className="modalCard">
                    <div className="menuImageContainer">
                        {selectedMenu?.image_name && selectedMenu?.image_name != null ?
                            <img
                                src={`${axios.defaults.baseURL}/statics/images/${selectedMenu?.image_name}`}
                                alt="منو آبنوس"/>
                            :
                            <img src={logo} alt="عکس منو"/>
                        }
                        <div className="closeModalContainer">
                            <button className="" onClick={() => {
                                setMenuModalOpen(false);
                            }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"
                                     fill="none">
                                    <rect y="4.43604" width="6.2735" height="32.0646" rx="3.13675"
                                          transform="rotate(-45 0 4.43604)" fill="white"/>
                                    <rect x="22.6731" width="6.2735" height="32.0646" rx="3.13675"
                                          transform="rotate(45 22.6731 0)" fill="white"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div className="menuInfo">
                        <h4>{selectedMenu.name}</h4>
                        <p>
                            {selectedMenu.desc}
                        </p>
                        <div className="priceContainer">
                            <NumericFormat
                                dir={"rtl"}
                                readOnly
                                name="selector"
                                className="input persianFont"
                                placeholder="900,000"
                                displayType="text"
                                thousandSeparator
                                value={selectedMenu?.price}
                            />
                            {" "}
                            تومان
                        </div>
                    </div>
                </div>
            </CenterModal>

            <Swiper
                direction={'vertical'}
                className="mySwiper"
                modules={[Navigation]}
                allowTouchMove={SWDisable}
                ref={props.swiperRef}
                onSlideChange={(swiper) => {
                    if (swiper.isEnd) {
                        setTimeout(() => {
                            props.onSetIsSwiped(true);
                            setSWDisable(false);
                        }, 500);
                    }
                }}
            >
                <SwiperSlide>
                    <div className="previewSlide" onClick={handleNextSlide}>
                        <div className="backgroundFilter"></div>
                        <div className="stationLogo"></div>

                        <div className="animationContainer">
                            {View}
                        </div>

                        <div className="infoContainer">
                            <p>
                                آدرس : مشهد، طرقبه، نبش عنبران ۴
                                <br/>
                                ساعت کار : ۱۲ ظهر الی ۱ بامداد
                            </p>
                            <p>تماس:</p>
                            <p>
                                <a href={"tel:+985134222445"}>
                                            <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"
                                         fill="none">
                                              <path
                                                  d="M8 2C8.71923 2.19302 9.37503 2.57183 9.9016 3.0984C10.4282 3.62497 10.807 4.28077 11 5"
                                                  stroke="white"
                                                  stroke-linecap="round" stroke-linejoin="round"/>
                                              <path
                                                  d="M7 3C7.72011 3.19125 8.37686 3.56946 8.9037 4.0963C9.43054 4.62314 9.80875 5.27989 10 6"
                                                  stroke="white"
                                                  stroke-linecap="round" stroke-linejoin="round"/>
                                              <path
                                                  d="M4.14432 6.53786C4.63736 7.55603 5.46067 8.37723 6.4801 8.86766C6.5553 8.90326 6.63848 8.91867 6.72144 8.91237C6.8044 8.90607 6.88429 8.87828 6.95325 8.83172L8.45055 7.83153C8.5167 7.78666 8.59314 7.75928 8.67274 7.75195C8.75233 7.74462 8.83249 7.75757 8.90572 7.7896L11.7087 8.99343C11.8045 9.0333 11.8845 9.10356 11.9364 9.19338C11.9884 9.2832 12.0094 9.38761 11.9961 9.49053C11.9073 10.1839 11.5689 10.8212 11.0441 11.2831C10.5194 11.745 9.84435 11.9998 9.14529 12C6.98503 12 4.91324 11.1418 3.3857 9.6143C1.85816 8.08676 1 6.01497 1 3.85471C1.00016 3.15565 1.25503 2.4806 1.71692 1.95587C2.17881 1.43114 2.81608 1.0927 3.50947 1.00386C3.61239 0.990636 3.7168 1.01161 3.80662 1.06356C3.89644 1.11551 3.9667 1.19554 4.00657 1.29134L5.2104 4.10027C5.2417 4.17234 5.2548 4.25102 5.24853 4.32935C5.24227 4.40768 5.21683 4.48327 5.17446 4.54945L4.17427 6.07071C4.12974 6.13951 4.1036 6.21859 4.09836 6.30038C4.09312 6.38217 4.10894 6.46394 4.14432 6.53786Z"
                                                  stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                </span>
                                    <span>۰۵۱۳۴۲۲۲۴۴۵</span>
                                </a>
                            </p>
                            <p>
                                <a href={"tel:+989153143981"}>
                                          <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                         fill="none">
                                         <path
                                             d="M11.0438 1.24552H4.46215C3.55019 1.24552 2.79134 1.98507 2.79134 2.9004V13.4502C2.79134 14.3647 3.53341 15.1051 4.46215 15.1051H11.0438C11.9558 15.1051 12.7146 14.3655 12.7146 13.4502V2.9004C12.7146 1.9859 11.9726 1.24552 11.0438 1.24552ZM11.9866 13.4502C11.9866 13.9684 11.5669 14.377 11.0438 14.377H4.46215C3.94032 14.377 3.51942 13.9537 3.51942 13.4502V2.9004C3.51942 2.38224 3.93908 1.97361 4.46215 1.97361H11.0438C11.5657 1.97361 11.9866 2.39695 11.9866 2.9004V13.4502Z"
                                             fill="white" stroke="white" stroke-width="0.25"/>
                                         <path
                                             d="M9.70518 2.75947H5.76892C5.57239 2.75947 5.40488 2.92699 5.40488 3.12351C5.40488 3.32004 5.57239 3.48756 5.76892 3.48756H9.70518C9.9017 3.48756 10.0692 3.32004 10.0692 3.12351C10.0692 2.92699 9.9017 2.75947 9.70518 2.75947Z"
                                             fill="white" stroke="white" stroke-width="0.25"/>
                                         <path
                                             d="M7.74502 11.8909C7.22815 11.8909 6.82321 12.3151 6.82321 12.8128C6.82321 13.0498 6.91395 13.2913 7.1012 13.4612C7.26991 13.6286 7.50869 13.7186 7.74502 13.7186C8.2619 13.7186 8.66684 13.2945 8.66684 12.7968C8.66684 12.2959 8.25862 11.8909 7.74502 11.8909ZM7.76096 13.0065C7.71547 13.0065 7.66729 12.9885 7.62624 12.9475C7.58519 12.9064 7.56724 12.8582 7.56724 12.8128C7.56724 12.7065 7.6547 12.619 7.76096 12.619C7.86722 12.619 7.95469 12.7065 7.95469 12.8128C7.95469 12.919 7.86722 13.0065 7.76096 13.0065Z"
                                             fill="white" stroke="white" stroke-width="0.25"/>
                                    </svg>
                                </span>
                                    <span>۰۹۱۵۳۱۴۳۹۸۱</span>
                                </a>
                            </p>
                            {/*<p className="linksContainer">*/}
                            {/*    <span>*/}
                            {/*        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="30" viewBox="0 0 22 30"*/}
                            {/*             fill="none">*/}
                            {/*          <path*/}
                            {/*              d="M11 0C4.92643 0 0 4.68011 0 10.45C0 18.2875 11 29.8571 11 29.8571C11 29.8571 22 18.2875 22 10.45C22 4.68011 17.0736 0 11 0ZM11 14.1821C8.83143 14.1821 7.07143 12.5101 7.07143 10.45C7.07143 8.38986 8.83143 6.71786 11 6.71786C13.1686 6.71786 14.9286 8.38986 14.9286 10.45C14.9286 12.5101 13.1686 14.1821 11 14.1821Z"*/}
                            {/*              fill="white"/>*/}
                            {/*        </svg>*/}
                            {/*    </span>*/}
                            {/*    <span>*/}
                            {/*        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31"*/}
                            {/*             fill="none">*/}
                            {/*        <path*/}
                            {/*            d="M15.418 9.13051C11.5908 9.13051 8.41975 12.2469 8.41975 16.1287C8.41975 20.0106 11.5362 23.127 15.418 23.127C19.2998 23.127 22.4162 19.9559 22.4162 16.1287C22.4162 12.3016 19.2452 9.13051 15.418 9.13051ZM15.418 20.612C12.9577 20.612 10.9347 18.5891 10.9347 16.1287C10.9347 13.6684 12.9577 11.6455 15.418 11.6455C17.8783 11.6455 19.9012 13.6684 19.9012 16.1287C19.9012 18.5891 17.8783 20.612 15.418 20.612Z"*/}
                            {/*            fill="white"/>*/}
                            {/*        <path*/}
                            {/*            d="M22.6896 10.552C23.5653 10.552 24.2751 9.84216 24.2751 8.96649C24.2751 8.09082 23.5653 7.38095 22.6896 7.38095C21.8139 7.38095 21.1041 8.09082 21.1041 8.96649C21.1041 9.84216 21.8139 10.552 22.6896 10.552Z"*/}
                            {/*            fill="white"/>*/}
                            {/*        <path*/}
                            {/*            d="M26.7901 4.86596C25.3686 3.38977 23.3457 2.62434 21.0494 2.62434H9.7866C5.02999 2.62434 1.85891 5.79541 1.85891 10.552V21.7601C1.85891 24.1111 2.62434 26.134 4.15521 27.6102C5.6314 29.0317 7.59965 29.7425 9.84127 29.7425H20.9947C23.3457 29.7425 25.3139 28.9771 26.7355 27.6102C28.2116 26.1887 28.9771 24.1658 28.9771 21.8148V10.552C28.9771 8.25573 28.2116 6.28748 26.7901 4.86596ZM26.5714 21.8148C26.5714 23.5097 25.97 24.8765 24.9859 25.806C24.0018 26.7354 22.6349 27.2275 20.9947 27.2275H9.84127C8.20106 27.2275 6.83422 26.7354 5.85009 25.806C4.86596 24.8219 4.3739 23.455 4.3739 21.7601V10.552C4.3739 8.91181 4.86596 7.54497 5.85009 6.56084C6.77954 5.63139 8.20106 5.13933 9.84127 5.13933H21.1041C22.7443 5.13933 24.1111 5.63139 25.0952 6.61552C26.0247 7.59964 26.5714 8.96649 26.5714 10.552V21.8148Z"*/}
                            {/*            fill="white"/>*/}
                            {/*        </svg>*/}
                            {/*    </span>*/}
                            {/*</p>*/}
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="abmousHome">
                        <div className="blankSpace"></div>
                        <Scrollbars
                            autoHide
                            autoHideTimeout={1000}
                            style={{minHeight: (height - 110), height: "auto", margin: "auto"}}
                            className="scroller"
                        >
                            <div className="contentData">
                                <div className="bannerImage"></div>

                                <div className="textContainer" id="textContainerId">
                                    <h2>درباره آبنوس</h2>
                                    <p>
                                        آبنوس، نه تنها مکانی برای چشیدن غذاهای بی‌نظیر ایرانی‌ست، بلکه جایی برای خلق
                                        خاطرات به
                                        یادماندنی
                                        شماست.
                                        <br/>
                                        این مجموعه با بیش از ۳ دهه تجربه در هنر آشپزی ایرانی، همواره در تلاش برای ارائه
                                        بهترین کیفیت
                                        و خدمات
                                        به همراهان خود بوده است.
                                        <br/>
                                        آبنوس در دل مناطق ییلاقی وسرسبز طرقبه، تجربه‌ای دلنشین از حضور در طبیعت و هوای
                                        آزاد را برای
                                        شما به
                                        ارمغان می‌آورد. این مجموعه رستورانی، با دارا بودن سالن‌های شیک سرپوشیده، شما را
                                        به دنیایی از
                                        آرامش و
                                        راحتی دعوت می‌کند و میزباندورهمی‌ها و مراسمات شما خواهد بود.
                                        <br/>
                                    </p>
                                </div>

                                <h2>منو</h2>
                                <div className="menuContainer" id="menuContainerId">
                                    <div className="content">
                                        <div onClick={() => {
                                            setMenuModalOpen(true);
                                            setSelectedMenu(menuList[0])
                                        }}
                                             className="card">
                                            <div className="imgContainer">
                                                {menuList[0] && menuList[0].image_name ?
                                                    <img
                                                        src={axios.defaults.baseURL + "/statics/images/" + menuList[0].image_name}
                                                        alt={"منو آبنوس"}
                                                    />
                                                    :
                                                    <img src={logo} alt={"عکس منو"}/>
                                                }

                                            </div>
                                            <h4>{menuList[0]?.name}</h4>
                                            <p>{menuList[0]?.desc}</p>
                                        </div>
                                        <div onClick={() => {
                                            setMenuModalOpen(true);
                                            setSelectedMenu(menuList[1])
                                        }}
                                             className="card">
                                            <div className="imgContainer">
                                                {menuList[1] && menuList[1].image_name ?
                                                    <img
                                                        src={axios.defaults.baseURL + "/statics/images/" + menuList[1].image_name}
                                                        alt={"منو آبنوس"}
                                                    />
                                                    :
                                                    <img src={logo} alt={"عکس منو"}/>
                                                }

                                            </div>
                                            <h4>{menuList[1]?.name}</h4>
                                            <p>{menuList[1]?.desc}</p>
                                        </div>
                                        <div onClick={() => {
                                            setMenuModalOpen(true);
                                            setSelectedMenu(menuList[2])
                                        }}
                                             className="card">
                                            <div className="imgContainer">
                                                {menuList[2] && menuList[2].image_name ?
                                                    <img
                                                        src={axios.defaults.baseURL + "/statics/images/" + menuList[2].image_name}
                                                        alt={"منو آبنوس"}
                                                    />
                                                    :
                                                    <img src={logo} alt={"عکس منو"}/>
                                                }

                                            </div>
                                            <h4>{menuList[2]?.name}</h4>
                                            <p>{menuList[2]?.desc}</p>
                                        </div>
                                        <div onClick={() => {
                                            setMenuModalOpen(true);
                                            setSelectedMenu(menuList[3])
                                        }}
                                             className="card">
                                            <div className="imgContainer">
                                                {menuList[3] && menuList[3].image_name ?
                                                    <img
                                                        src={axios.defaults.baseURL + "/statics/images/" + menuList[3].image_name}
                                                        alt={"منو آبنوس"}
                                                    />
                                                    :
                                                    <img src={logo} alt={"عکس منو"}/>
                                                }

                                            </div>
                                            <h4>{menuList[3]?.name}</h4>
                                            <p>{menuList[3]?.desc}</p>
                                        </div>

                                    </div>

                                    <Link to={"/menu"}
                                          style={{display: "flex", margin: "30px 0", textDecoration: "none"}}>
                                        <button>مشاهده منو</button>
                                    </Link>

                                </div>

                                <h2>تصاویر</h2>
                                <div className="galleryContainer" id="galleryContainerId">
                                    <Gallery/>
                                </div>

                                <h2>تماس با ما</h2>
                                <div className="complexInfo" id="conractUsId">
                                    <div className="addressBar">

                                        <p>
                                            <a href="https://maps.app.goo.gl/7aTChVeEPCNGJGZz9" target="_blank">
                                                آدرس: مشهد، طرقبه، نبش عنبران ۴
                                                <br/>
                                                ساعت کار : ۱۲ ظهر الی ۱ بامداد
                                            </a>
                                        </p>

                                        <p>تماس :</p>
                                        <p>
                                            <a href="tel:+985134222445" target="_blank">
                                                ۰۵۱۳۴۲۲۲۴۴۵
                                            </a>
                                        </p>
                                        <p>
                                            <a href="tel:+989153143981" target="_blank">
                                                ۰۹۱۵۳۱۴۳۹۸۱
                                            </a>
                                        </p>
                                        <p>
                                            <a href="https://www.instagram.com/abnous.restaurant" target="_blank">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="69" height="69"
                                                     viewBox="0 0 69 69"
                                                     fill="none">
                                                    <path
                                                        d="M34.3174 20.3228C25.7989 20.3228 18.7407 27.2593 18.7407 35.8995C18.7407 44.5397 25.6772 51.4762 34.3174 51.4762C42.9577 51.4762 49.8942 44.418 49.8942 35.8995C49.8942 27.381 42.836 20.3228 34.3174 20.3228ZM34.3174 45.8783C28.8413 45.8783 24.3386 41.3757 24.3386 35.8995C24.3386 30.4233 28.8413 25.9206 34.3174 25.9206C39.7936 25.9206 44.2963 30.4233 44.2963 35.8995C44.2963 41.3757 39.7936 45.8783 34.3174 45.8783Z"
                                                        fill="white"/>
                                                    <path
                                                        d="M50.5027 23.4868C52.4518 23.4868 54.0318 21.9068 54.0318 19.9577C54.0318 18.0086 52.4518 16.4286 50.5027 16.4286C48.5537 16.4286 46.9736 18.0086 46.9736 19.9577C46.9736 21.9068 48.5537 23.4868 50.5027 23.4868Z"
                                                        fill="white"/>
                                                    <path
                                                        d="M59.6298 10.8307C56.4657 7.54498 51.9631 5.84128 46.852 5.84128H21.7832C11.1959 5.84128 4.1377 12.8995 4.1377 23.4868V48.4339C4.1377 53.6667 5.8414 58.1693 9.24881 61.455C12.5345 64.6191 16.9155 66.2011 21.9049 66.2011H46.7303C51.9631 66.2011 56.344 64.4974 59.5081 61.455C62.7938 58.291 64.4975 53.7884 64.4975 48.5556V23.4868C64.4975 18.3757 62.7938 13.9947 59.6298 10.8307ZM59.143 48.5556C59.143 52.328 57.8044 55.3704 55.6139 57.4392C53.4234 59.5079 50.3811 60.6032 46.7303 60.6032H21.9049C18.2541 60.6032 15.2118 59.5079 13.0213 57.4392C10.8308 55.2487 9.73558 52.2064 9.73558 48.4339V23.4868C9.73558 19.836 10.8308 16.7937 13.0213 14.6032C15.0901 12.5344 18.2541 11.4392 21.9049 11.4392H46.9737C50.6245 11.4392 53.6668 12.5344 55.8573 14.7249C57.9261 16.9154 59.143 19.9577 59.143 23.4868V48.5556Z"
                                                        fill="white"/>
                                                </svg>
                                            </a>
                                        </p>
                                    </div>
                                    <div className="mapContainer">
                                        <Link to="https://maps.app.goo.gl/nk9UdfBuz7zqjkje6" target="_blank">
                                            <img src="./map.png" alt="آدرس آبنوس"/>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="blankSpace"></div>
                        </Scrollbars>

                    </div>
                </SwiperSlide>
            </Swiper>
        </div>
    );
}

export default HomePage;
